import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import {
	FieldShell,
	fieldClassName,
	fieldErrorClassName,
	fieldId,
} from "@/components/ui/field";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	error?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
	({ className, type, label, error, id, ...props }, ref) => {
		const inputId = fieldId(id, label);

		return (
			<FieldShell id={inputId} label={label} error={error}>
				<input
					id={inputId}
					type={type}
					className={cn(
						fieldClassName,
						"flex h-9",
						error && fieldErrorClassName,
						className,
					)}
					ref={ref}
					{...props}
				/>
			</FieldShell>
		);
	},
);

Input.displayName = "Input";

export { Input };
